import angular from 'angular';

import AdBuilderController from './controller';
import builderHeader from './header.directive';
import BuilderHeaderController from './header.controller';
import creativeBuilder from './creative_builder.directive';
import creativeBuilderCard from './creative_builder_card.directive';
import CreativeBuilderController from './creative_builder.controller';
import CreativeBuilderCardController from './creative_builder_card.controller';
import MediaUrlFieldDirective from './media_url_field.directive';
import DescriptionFieldDirective from './description_field.directive';
import EnhancedDisplayBuilderDirective from './enhanced_display_builder.directive';
import DynamicNativeBuilder from './dynamic_native_builder.directive';
import FullAdCarouselBuilderDirective from './full_ad_carousel_builder.directive';
import HeadlineFieldDirective from './headline_field.directive';
import { nativeDisplayBuilder } from './native_display_builder.directive';
import nativeOutsreamBuilder from './native_outstream_builder.directive';
import instreamVideoBuilder from './instream_video_builder.directive';
import { scrollerBuilder } from './scroller_builder.directive';
import SlideshowBuilderDirective from './slideshow_builder.directive';
import strAdBuilder from './ad_builder.directive';
import VideoService from './video.service';
import oldThumbnailUpload from './old_thumbnail_upload.directive';

angular.module('generator.adBuilder', [
  'generator.analytics',
  'generator.creatives',
  'generator.creativePreview',
  'generator.dsp',
  'generator.shared'
]);

angular
  .module('generator.adBuilder')
  .controller('AdBuilderController', AdBuilderController)
  .controller('BuilderHeaderController', BuilderHeaderController)
  .controller('CreativeBuilderCardController', CreativeBuilderCardController)
  .controller('CreativeBuilderController', CreativeBuilderController)
  .directive('builderHeader', builderHeader)
  .directive('mediaUrlField', MediaUrlFieldDirective)
  .directive('creativeBuilder', creativeBuilder)
  .directive('creativeBuilderCard', creativeBuilderCard)
  .directive('descriptionField', DescriptionFieldDirective)
  .directive('headlineField', HeadlineFieldDirective)
  .directive('nativeDisplayBuilder', nativeDisplayBuilder)
  .directive('nativeOutstreamBuilder', nativeOutsreamBuilder)
  .directive('instreamVideoBuilder', instreamVideoBuilder)
  .directive('scrollerBuilder', scrollerBuilder)
  .directive('enhancedDisplayBuilder', EnhancedDisplayBuilderDirective)
  .directive('dynamicNativeBuilder', DynamicNativeBuilder)
  .directive('fullAdCarouselBuilder', FullAdCarouselBuilderDirective)
  .directive('slideshowBuilder', SlideshowBuilderDirective)
  .directive('strAdBuilder', strAdBuilder)
  .directive('oldThumbnailUpload', oldThumbnailUpload)
  .factory('VideoService', VideoService);
